(() => {
  if (customElements.get('announcement-bar')) {
    return;
  }

  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.resizeTimeout = null;
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.initSlider();
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
    }

    handleResize() {
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }

      this.resizeTimeout = setTimeout(() => {
        this.equalizeSlideHeights();
      }, 250);
    }

    initSlider() {
      const sliderElement = this.querySelector('[data-slider]');
      if (!sliderElement) return;

      const options = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 500,
        autoHeight: false,
      };

      if (this.hasAttribute('data-autoplay')) {
        const autoplaySpeed = this.dataset.autoplaySpeed || 3000;
        options.autoplay = {
          delay: parseInt(autoplaySpeed, 10),
          disableOnInteraction: false,
        };
      }

      this.slider = new Swiper(sliderElement, options);

      // Ensure all slides have equal height
      this.equalizeSlideHeights();
    }

    equalizeSlideHeights() {
      const slides = this.querySelectorAll('.swiper-slide');
      if (slides.length === 0) return;

      let maxHeight = 0;

      // First, reset heights to auto to get natural heights
      slides.forEach(slide => {
        slide.style.height = 'auto';
      });

      // Find the tallest slide
      slides.forEach(slide => {
        const height = slide.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      // Set all slides to the same height
      if (maxHeight > 0) {
        slides.forEach(slide => {
          slide.style.height = `${maxHeight}px`;
        });
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
})();

